const getterNames = Object.freeze({
    getProfile: 'GET_PROFILE',
    loading: 'GET_LOADING',
} as const);

const mutationNames = Object.freeze({
    setProfile: 'SET_PROFILE',
    setLoading: 'SET_LOADING',
    setError: 'SET_ERROR',
} as const);

const actionNames = Object.freeze({
    fetchMyProfile: 'FETCH_MY_PROFILE',
} as const);

const namespace = 'assessorState';

export { getterNames, mutationNames, actionNames, namespace };
